import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { TimePicker } from "@design-system/TimePicker/TimePicker";
import { formatDuration } from "@design-system/TimePicker/TimePicker.lib";
import { CaptureClicks } from "@design-system/CaptureClicks/CaptureClicks";
import { EditableCellContent } from "@design-system/ViewTable/EditableCellContent";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { ViewTableMeta } from "@hooks/view/useViewTableMeta";
import {
    CloseTemplateTaskCallbacks,
    CloseTemplateTaskRow,
} from "../closeTemplateTasksViewConfig";

type Meta = ViewTableMeta<CloseTemplateTaskCallbacks, never>;

export const CloseTemplateTaskEstimateCell = memo(
    function CloseTemplateTaskEstimateCell({
        row,
        table,
    }: CellContext<ViewTableFeatures, CloseTemplateTaskRow, number | null>) {
        const meta = (table.options.meta ?? {}) as Meta;
        const item = row.original;

        if (item.isGroupRow) {
            return null;
        }

        const formattedValue = formatDuration(item.estimatedTime ?? undefined);

        return (
            <ViewTableCell>
                <div>
                    <CaptureClicks>
                        <TimePicker
                            hideIcon
                            value={item.estimatedTime ?? undefined}
                            onChange={(value) =>
                                meta.callbacks?.onUpdateEstimatedTime(
                                    item.id,
                                    value ?? null,
                                )
                            }
                            trigger={
                                <EditableCellContent
                                    isEmpty={!item.estimatedTime}
                                    addText="Add estimate"
                                    hideIcon
                                >
                                    {formattedValue}
                                </EditableCellContent>
                            }
                        />
                    </CaptureClicks>
                </div>
            </ViewTableCell>
        );
    },
);
